import { render } from "./NFTCard.vue?vue&type=template&id=c37594a6&scoped=true&ts=true"
import script from "./NFTCard.vue?vue&type=script&lang=ts"
export * from "./NFTCard.vue?vue&type=script&lang=ts"

import "./NFTCard.vue?vue&type=style&index=0&id=c37594a6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c37594a6"]])

export default __exports__